import { api } from "@/lib/api";
import { toast } from "sonner";
import { FolderOpen, DownloadSimple, FilePdf, FileXls } from "@phosphor-icons/react";

export default function DataRoomTab({ doc }) {
  const folders = doc.data_room || [];

  const download = async (fmt) => {
    const t = toast.loading(`Preparing ${fmt.toUpperCase()}…`);
    try {
      const resp = await api.get(`/investment-docs/${doc.id}/export/data-room.${fmt}`, { responseType: "blob" });
      const url = URL.createObjectURL(resp.data); const a = document.createElement("a"); a.href = url;
      a.download = `${(doc.company_name || "orixa-invest").replace(/\s+/g, "-").toLowerCase()}-data-room-index.${fmt}`;
      a.click(); URL.revokeObjectURL(url); toast.success(`${fmt.toUpperCase()} downloaded`, { id: t });
    } catch { toast.error("Download failed", { id: t }); }
  };

  return (
    <div className="space-y-6" data-testid="idoc-tab-data-room-body">
      <div className="bg-teal-soft/50 border border-teal/30 rounded-2xl p-5 flex items-start gap-4">
        <FolderOpen size={22} weight="duotone" className="text-primary flex-shrink-0 mt-1" />
        <div className="text-sm text-foreground leading-relaxed">
          Your data room is pre-organised into the 10 standard institutional folders. File uploads are enabled per organisation via the <strong>Knowledge Vault</strong> — investors can be granted read-only access once you finalise the package.
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {folders.map((f) => (
          <div key={f.key} className="bg-card border border-border rounded-2xl p-5 card-elev hover:card-elev-lg transition-shadow" data-testid={`dr-folder-${f.key}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="h-10 w-10 rounded-lg bg-teal-soft text-teal grid place-items-center">
                <FolderOpen size={20} weight="duotone" />
              </div>
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">
                {(f.files || []).length} files
              </div>
            </div>
            <div className="mt-4 font-display text-lg tracking-tight">{f.label}</div>
            <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{f.hint}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-2 justify-end">
        <button onClick={() => download("pdf")} className="inline-flex items-center gap-2 border border-border bg-card rounded-lg px-4 py-2.5 text-sm font-semibold hover:bg-secondary" data-testid="dr-download-pdf">
          <FilePdf size={14} weight="duotone" /> Index PDF
        </button>
        <button onClick={() => download("xlsx")} className="inline-flex items-center gap-2 border border-border bg-card rounded-lg px-4 py-2.5 text-sm font-semibold hover:bg-secondary" data-testid="dr-download-xlsx">
          <FileXls size={14} weight="duotone" /> Index XLSX
        </button>
      </div>
    </div>
  );
}
